import { render, staticRenderFns } from "./relic-upload-choose.vue?vue&type=template&id=3693cd6d"
import script from "./relic-upload-choose.vue?vue&type=script&lang=js"
export * from "./relic-upload-choose.vue?vue&type=script&lang=js"
import style0 from "./relic-upload-choose.vue?vue&type=style&index=0&id=3693cd6d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports